import { useNavigate } from "react-router-dom";
import ActionTypes from "../../store/actionTypes";
import wordFile from '../../assets/wordFiles/Reporting_tool-Device_protection_plan_User_Manual.docx'
import AsurionLogo from '../../assets/icons/asurionLogo'
import Logout from '../../assets/icons/icon-logout'
import StarhubLogo from '../../assets/icons/starhubLogo'
import { getUserManuals, toPascalCase } from "../../utils/functionUtils"
import { Button } from 'antd'
import { useCentralStore } from "../../store/appContext";
import Download from "../../assets/icons/downloadNew";
import API from "../../api";
import { getCarrierByDomain } from "../../domain";

const SGPLanding = ({
    resources,
    gotoDashboard,
    userDetails
}) => {
    const [{ carrierThemeData }, dispatch] = useCentralStore();
    const { theme, reportingSummarySections, keySections } = carrierThemeData;
    
    // let setions = [
    //     {label:'Real Time Service Request Status', value: 'Real Time Service Request Report', icon: <img src={RealtimeSRSIcon} />, 
    //         subLabels: [
    //             {label: 'Real Time', value: 'Real Time', parentLabel:'Real Time Service Request Report'},
    //             {label: 'Monthly Trends', value: 'Monthly Trends', parentLabel:'Real Time Service Request Report'},
    //             {label: 'Glossary', value: 'Glossary', parentLabel:'Real Time Service Request Report'},
    //         ]},
    //     {label:'Customer SLA', value: 'Customer Service SLA Report', icon: <img src={CustomerSLAIcon} />, 
    //     subLabels: [
    //         {label: 'Prev Month', value: 'Prev Month', parentLabel:'Customer Service SLA Report'},
    //         {label: 'Monthly Trends', value: 'Monthly Trends', parentLabel:'Customer Service SLA Report'},
    //         {label: 'Glossary', value: 'Glossary', parentLabel:'Customer Service SLA Report'}
    //     ]},
    //     {label:'Technical SLA ', value: 'Technical Service SLA Report', icon: <img src={TechnicalSLAIcon} />, 
    //     subLabels: [
    //         {label: 'Prev Month', value: 'Prev Month', parentLabel:'Technical Service SLA Report'},
    //         {label: 'Monthly Trends', value: 'Monthly Trends', parentLabel:'Technical Service SLA Report'},
    //         {label: 'Glossary', value: 'Glossary', parentLabel:'Technical Service SLA Report'}
    //     ]},
    //     {label:'Program Summary', value: 'Program Summary',parentLabel: 'Program Summary', icon: <img src={ProgramSummaryIcon} />},
    //     {label:'Finance Reconciliation & Invoice', value: 'Finance Reconciliation & Invoice', icon: <img src={FiancanceReconIcon} />,
    //     subLabels: [
    //         {label: 'Finance Recon & Invoice', value: 'Finance Reconciliation & Invoice', parentLabel:'Finance Reconciliation & Invoice'},
    //         {label: 'Rebate To Starhub', value: 'SLA Report', parentLabel:'Finance Reconciliation & Invoice'},
    //         {label: 'Glossary', value: 'Glossary', parentLabel:'Finance Reconciliation & Invoice'}
    //     ]}
    // ]

    const setLoading = (action) => {
        dispatch({ type: ActionTypes.SET_LOADING_DATA, payload: action });
      };

    const navigate = useNavigate();
    const handleClick = ()=>{
        setLoading(true)
        API[ActionTypes.SIGNOUT_REQUEST]()
        .then((data) => {
            setLoading(false)
            navigate("/login");
            dispatch({
                type: ActionTypes.SET_USER_LOGGED_IN,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SET_EMAIL_ADDRESS,
                payload: "",
            });
            dispatch({
                type: ActionTypes.SET_PASSWORD,
                payload: "",
            });
            dispatch({
                type: ActionTypes.GET_STARHUB_REPORT_COUNT_SUCCESS,
                payload: undefined,
            });
            dispatch({
                type: ActionTypes.SET_SELECTED_TAB,
                payload: undefined,
            });
            dispatch({
                type: ActionTypes.SET_PROJECT_NAME,
                payload: undefined,
            });
            dispatch({
                type: ActionTypes.SET_PROGRAM_NAME,
                payload: undefined,
            });
            })
        .catch((err) => {
            setLoading(false)
            console.log(`error is ${err}`);
            });
        
        // navigate("/login");
    }

    const handleDownload = (e, placeholder) => {
        const link = document.createElement('a');
        link.href = getUserManuals(getCarrierByDomain()?.toLowerCase())
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDownloadReports = (e, placeholder) => {
        dispatch({ type: ActionTypes.SET_PROJECT_NAME, payload: 'Download Reports' });
        dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: undefined });
        dispatch({ type: ActionTypes.SET_PROJECT_SUB_MENU, payload: undefined });
    };   

    const dynamicStyle = {
        '--border-color': '#D9D9D9',
        '--font-color': theme?.colors?.textWhiteColor,
    };

    return(
        <div className="p-5 pt-0 flex flex-col w-[85%] mx-auto">
            {/* <div className="flex flex-row items-center justify-end">
                <span className={' text-base mr-5 font-bold textFontStyle'} style={dynamicStyle}>
                {userDetails && toPascalCase(userDetails?.firstName)}{" "}{userDetails && toPascalCase(userDetails?.lastName)}
                {userDetails && toPascalCase(userDetails?.split('@')[0]?.split('.')[0]) + ' ' + toPascalCase(userDetails?.split('@')[0]?.split('.')[1])}
                </span>
                <Button 
                    className='bg-white borderStyle flex items-center cursor-pointer text-black font-bold hover:text-gray-400 border-2' 
                    onClick={() => handleClick()}
                    style={dynamicStyle}
                >
                    Logout 
                    <Logout className="ml-2"/>
                </Button>
            </div>
            <div className="flex flex-row justify-end mt-2 cursor-pointer gap-1"> */}
                {/* <p onClick={handleDownloadReports} style={dynamicStyle} className="text-sm font-bold flex float-right text-right textFontStyle hover:text-gray-300 cursor-pointer underline">Download Reports Here!! </p>
                <Download fill={theme?.colors?.textWhiteColor} onClick={handleDownloadReports} className="pt-2px h-5 w-5 mr-2"/> */}
                {/* <p onClick={handleDownload} style={dynamicStyle} className="text-sm font-bold flex text-right textFontStyle hover:text-gray-300 cursor-pointer underline">Download user manual here!! </p>
                <Download fill={theme?.colors?.textWhiteColor} onClick={handleDownload} className="pt-2px h-5 w-5"/>
            </div> */}
            {/* <div className="flex flex-row justify-center mb-2 mt-3">
                <img
                className="max-w-18 m-2 h-[50px] mr-3"
                src={theme?.logo}
              />
                <p className="text-[36px] text-black">{carrierThemeData?.program}</p>
            </div> */}
            <p className={`text-3xl text-center text-[#363636]`}>
                {resources.LANDING_HEADER.replace(
                    "{username}", (userDetails && toPascalCase(userDetails?.split('@')[0]?.split('.')[0]) || 'Guest')
                    // userDetails?.firstName ? toPascalCase(userDetails?.firstName):"Guest"
                )}
                </p>
                <p className="mb-4 text-3xl text-center text-[#363636]">{resources.LANDING_SUB_HEADER}</p>
                {/* {sections?.map(v => 
                        {return(
                            <div className="borderStyle mb-5 cursor-pointer w-[190px] ml-5 flex flex-col items-center text-black rounded-xl py-8 px-2 font-semibold text-sm transition duration-500 ease-in-out delay-350 hover:-translate-y-0 hover:scale-y-110 hover:scale-x-110"
                            style={dynamicStyle}
                                onClick={() => gotoDashboard(v?.value, v)}>
                                    <img src={v.icon} style={{ height: '175px' }} />
                                    <p className="mt-5 text-center">{v.label}</p>
                            </div>
                        )}
                    )} */}
                <div className="mb-5">
                    <p className="mb-3 mt-3 text-xl font-semibold text-center text-[#363636]">Key actions</p>
                    <div className="flex flex-row flex-wrap justify-center mx-auto w-full">
                        {keySections?.map((v, i) => 
                            {return(
                                <div className={`${i === 0 ? '' : 'ml-8'} borderStyle cursor-pointer min-w-[45%] flex flex-col items-center text-black rounded-xl p-2 font-semibold text-sm transition duration-500 ease-in-out delay-350 hover:-translate-y-0 hover:scale-y-110 hover:scale-x-110`}
                                style={dynamicStyle}
                                    onClick={() => gotoDashboard(v?.value, v)}>
                                        <img src={v.icon} style={{ height: '100px' }} />
                                        <p className="text-center text-lg">{v.label}</p>
                                </div>
                            )}
                        )}
                    </div>
                    <p className="mt-5 mb-3 text-xl text-center text-[#363636] font-semibold">Reporting and summary</p>
                    <div className="flex flex-row flex-wrap justify-center mx-5">
                        {reportingSummarySections?.map((v, i) => 
                            {return(
                                <div className={`${i === 0 ? '' : 'ml-8'} mt-3 borderStyle cursor-pointer min-w-[30%] flex items-start text-black rounded-xl p-2 font-semibold text-sm transition duration-500 ease-in-out delay-350 hover:-translate-y-0 hover:scale-y-110 hover:scale-x-110`}
                                style={dynamicStyle}
                                    onClick={() => gotoDashboard(v?.value, v)}>
                                        <img src={v.icon} style={{ height: '100px' }} />
                                        <p className="ml-2 mt-5 text-lg">{v.label}</p>
                                </div>
                            )}
                        )}
                    </div>
                </div>
            {/* <div className="flex justify-center items-center">
             <p className="text-black mr-1 font-bold">Powered by</p>
             <AsurionLogo className="text-center my-4" />
            </div> */}
        </div>
    )
}

export default SGPLanding